import clsx from 'clsx';

export type SpacerProps = {
  className?: string;
};

/**
 * In a HStack or a VStack, expand to use all the free space.
 *
 * @see HStack or VStack
 */
export const Spacer = (props: SpacerProps) => {
  const { className } = props;

  return <div className={clsx('flex-fill', className)} />;
};
